<template>
    <div class="px-4 d-flex flex-column justify-content-around">
        <div class="d-flex align-items-center cursor-pointer flex-grow-1" @click="$router.push({'name': 'contact us'})">
            <i-contact-us height="2.5em" width="2.5em"></i-contact-us>

            <h5 class="mx-3 mb-0">
                {{t('Contact us')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div class="d-flex align-items-center cursor-pointer flex-grow-1" @click="$router.push({'name': 'about us'})">
            <i-about height="2.5em" width="2.5em"></i-about>

            <h5 class="mx-3 mb-0">
                {{t('About us')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div class="d-flex align-items-center cursor-pointer flex-grow-1"
             @click="$router.push({'name': 'health care providers'})">
            <i-health-care height="2.5em" width="2.5em"></i-health-care>

            <h5 class="mx-3 mb-0">
                {{t('POS')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div v-b-modal:change-language class="d-flex align-items-center cursor-pointer flex-grow-1">
            <i-translate height="2.5em" width="2.5em"></i-translate>

            <h5 class="mx-3 mb-0">
                {{t('Change language')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div v-b-modal:change-country class="d-flex align-items-center cursor-pointer flex-grow-1">
            <i-home height="2.5em" width="2.5em"></i-home>

            <h5 class="mx-3 mb-0">
                {{t('Change country')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div class="d-flex align-items-center cursor-pointer flex-grow-1"
             @click="$router.push({'name': 'menu guide'})">
            <i-guide height="2.5em" width="2.5em"></i-guide>

            <h5 class="mx-3 mb-0">
                {{t('Guide')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div class="d-flex align-items-center cursor-pointer flex-grow-1" @click="$router.push({'name': 'privacy-policy'})">
            <i-privacy height="2.5em" width="2.5em"></i-privacy>

            <h5 class="mx-3 mb-0">
                {{t('Privacy policy')}}
            </h5>
        </div>

        <hr class="m-0 border-gray">

        <div class="d-flex align-items-center cursor-pointer flex-grow-1" @click="logout">
            <i-logout height="2.5em" width="2.5em"></i-logout>

            <h5 class="mx-3 mb-0">
                {{t('Logout')}}
            </h5>
        </div>

        <b-modal id="change-language" :title="t('Change language')" scrollable centered title-class="text-capitalize"
                 header-class="pl-4"
                 footer-class="justify-content-center"
                 content-class="border-radius-1">
            <b-form id="change-language-form" @submit.prevent="change">
                <b-form-group>
                    <b-form-radio-group stacked v-model="lang">
                        <b-form-radio value="en">English</b-form-radio>
                        <b-form-radio value="ar">Arabic</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-form>

            <template v-slot:modal-footer="{cancel}">
                <b-button @click="cancel" class="mx-2 px-4" pill variant="secondary">{{t('Cancel')}}</b-button>
                <b-button type="submit" form="change-language-form" class="mx-2 px-4" pill variant="primary">
                    {{t('Submit')}}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="change-country" :title="t('Change country')" scrollable centered title-class="text-capitalize"
                 header-class="pl-4"
                 footer-class="justify-content-center"
                 content-class="border-radius-1">
            <b-form id="change-country-form" @submit.prevent="changeCountry">
                <b-form-group class="mb-0">
                    <b-overlay :show="show">
                        <b-input-group>
                            <b-select v-model="country" required>
                                <option :value="null" disabled>{{t('Choose your country')}}</option>
                                <option v-for="country in countries" :value="country.id">{{country['name_en']}}</option>
                            </b-select>
                        </b-input-group>
                    </b-overlay>
                </b-form-group>
            </b-form>

            <template v-slot:modal-footer="{cancel}">
                <b-button @click="cancel" class="mx-2 px-4" pill variant="secondary">{{t('Cancel')}}</b-button>
                <b-button type="submit" form="change-country-form" class="mx-2 px-4" pill variant="primary">
                    {{t('Submit')}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import IContactUs from "../components/Icons/IContactUs";
    import IAbout from "../components/Icons/IAbout";
    import IGuide from "../components/Icons/IGuide";
    import IHealthCare from "../components/Icons/IHealthCare";
    import ILogout from "../components/Icons/ILogout";
    import ITranslate from "../components/Icons/ITranslate";
    import IHome from "../components/Icons/IHome";
    import IPrivacy from "../components/Icons/IPrivacy";

    export default {
        name: "Menu",
        inject: ['localStorageRepo', 'dataRepo'],
        components: {
            IContactUs,
            IAbout,
            IGuide,
            IHome,
            IHealthCare,
            ILogout,
            ITranslate,
            IPrivacy
        },
        data: () => ({
            lang: localStorage.getItem('locale') || 'en',
            show: false,
            country: null,
            countries: []
        }),
        methods: {
            logout() {
                const tokenID = this.localStorageRepo.getTokenId();

                if (tokenID) {
                    this.dataRepo.deletePatientToken(tokenID);
                    this.localStorageRepo.removeTokenId();
                }

                this.localStorageRepo.removeUser();
                this.localStorageRepo.removeCountry();
                this.$router.push({name: 'login'});
            },

            change() {
                const lang = this.lang;
                localStorage.setItem('locale', lang);
                this.$translate.setLang(lang);
                document.querySelector('body').setAttribute('dir', lang === 'en' ? 'ltr' : 'rtl')
                document.querySelector('html').setAttribute('lang', lang)
                this.$bvModal.hide('change-language');
            },

            changeCountry() {
                this.localStorageRepo.setCountry(this.country);
                this.$bvModal.hide('change-country');
            }
        },
        mounted() {
            this.country = this.localStorageRepo.getCountry();

            this.dataRepo.countries().then(({data}) => {
                this.countries = data
            })
                .catch(err => this.$handleError(err))
                .finally(() => this.show = false);
        }
    }
</script>

<style scoped>

</style>
